import React, { Component, Fragment } from "react";
import Breadcrumb from "../common/breadcrumb";
import "react-toastify/dist/ReactToastify.css";
import { ToastContainer, toast } from "react-toastify";
import { Tabs, TabList, TabPanel, Tab } from "react-tabs";
import Datatable from "./afterSaleDatatable";
import {
  getAllAfterSaleRedux,
  getApprovedAfterSaleRedux,
} from "../../actions/index";
import { Link } from "react-router-dom";
import { connect } from "react-redux";
import { Search } from "react-feather";
import MakeRefundAfterSaleModal from "./makeRefundAfterSaleModal";

const THIRTY_DAYS_MS = 30 * 24 * 60 * 60 * 1000;

class RefundRequestOrder extends Component {
  constructor(props) {
    super(props);
    this.state = {
      searchFor: "",
      approvedSearchOrderId: "",
      open: false,
      toggleModal: true,
      payableOrders: [],
      refundRequest: null,
    };
  }

  componentDidMount = async () => {
    this.props.getAllAfterSaleRedux();
    this.props.getApprovedAfterSaleRedux();
  };

  startToggleModal = async (refundRequest) => {
    if (refundRequest) {
      this.setState({
        toggleModal: false,
        refundRequest,
      });
    } else {
      this.setState({
        toggleModal: true,
        refundRequest: null,
      });
    }
  };

  handleSearchBarChange = (event) => {
    const { name, value } = event.target;
    this.setState({ [name]: value });
  };

  getRefundRequestArray = () => {
    console.log(this.props.allRefundRequests);
    if (!this.state.searchFor) {
      return this.props.allRefundRequests;
    }

    let filterByStatus = this.props.allRefundRequests.filter((refundRequest) =>
      refundRequest.status
        .toLowerCase()
        .includes(this.state.searchFor.toLowerCase())
    );
    let filterByMethod = this.props.allRefundRequests.filter((refundRequest) =>
      refundRequest.method
        .toLowerCase()
        .includes(this.state.searchFor.toLowerCase())
    );

    return [...filterByStatus, ...filterByMethod];
  };

  getApprovedRefundRequestArray = () => {
    const all = this.props.allApprovedRefundRequests || [];
    const searchId = this.state.approvedSearchOrderId.trim().toLowerCase();

    if (searchId) {
      // Search looks across all approved history, not just the last 30 days.
      return all.filter((refundRequest) => {
        const orderId = refundRequest.order?.orderId || refundRequest.order?.bookingId || "";
        return (
          String(refundRequest.refundId || "").toLowerCase().includes(searchId) ||
          String(orderId).toLowerCase().includes(searchId)
        );
      });
    }

    const cutoff = Date.now() - THIRTY_DAYS_MS;
    return all.filter((refundRequest) => (refundRequest.time || 0) >= cutoff);
  };

  render() {
    const { open } = this.state;

    return (
      <Fragment>
        <MakeRefundAfterSaleModal
          toggleModal={this.state.toggleModal}
          startToggleModal={this.startToggleModal}
          payableOrders={this.state.payableOrders}
          refundRequestObj={this.state.refundRequest}
        />
        <Breadcrumb title="Refund Request" parent="Payment" />
        {/* <!-- Container-fluid starts--> */}
        <div className="container-fluid">
          <div className="row">
            <div className="col-sm-12">
              <div className="card">
                <div
                  className="card-header"
                  style={{
                    display: "flex",
                    flexDirection: "row",
                    justifyContent: "space-between",
                  }}
                >
                  <h5>
                    {" "}
                    <i
                      className="fas fa-money-check-alt"
                      style={{
                        fontSize: "180%",
                        marginRight: "5px",
                        marginTop: "5px",
                        color: "#ff8084",
                      }}
                    ></i>
                    Refund Request
                  </h5>
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "row",
                      justifyContent: "space-around",
                    }}
                  >
                    {" "}
                    <li
                      style={{
                        border: "1px solid gainsboro",
                        borderRadius: "5rem",
                        padding: "0px 20px",
                        background: "whitesmoke",
                        marginRight: "20px",
                      }}
                    >
                      <form
                        className="form-inline search-form"
                        onSubmit={this.handleSubmit}
                      >
                        <div
                          // className="form-group"
                          style={{
                            display: "flex",
                            flexDirection: "row",
                            justifyContent: "space-around",
                          }}
                        >
                          <input
                            className={
                              "form-control-plaintext " +
                              (this.state.searchbar ? "open" : "")
                            }
                            name="searchFor"
                            value={this.state.searchFor}
                            type="search"
                            placeholder="Search Payment Request"
                            onChange={this.handleSearchBarChange}
                          />
                          <span
                          // className="d-sm-none mobile-search"
                          >
                            <Search
                              style={{
                                marginTop: "5px",
                                borderLeft: "1px solid gainsboro",
                                paddingLeft: "7px",
                                color: "gray",
                              }}
                            />
                          </span>
                        </div>
                      </form>
                    </li>
                    <li></li>
                  </div>
                </div>
                <div className="card-body">
                  <div className="clearfix"></div>
                  <Tabs>
                    <TabList>
                      <Tab>Pending</Tab>
                      <Tab>Approved</Tab>
                    </TabList>
                    <TabPanel>
                      <div id="basicScenario" className="product-physical">
                        <Datatable
                          startToggleModal={this.startToggleModal}
                          history={this.props.history}
                          multiSelectOption={false}
                          myData={this.getRefundRequestArray()}
                          pageSize={100}
                          pagination={true}
                          class="-striped -highlight"
                        />
                      </div>
                    </TabPanel>
                    <TabPanel>
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "row",
                          justifyContent: "flex-end",
                          padding: "15px 0",
                        }}
                      >
                        <input
                          type="search"
                          name="approvedSearchOrderId"
                          value={this.state.approvedSearchOrderId}
                          onChange={this.handleSearchBarChange}
                          placeholder="Search by Refund/Order Id"
                          className="form-control"
                          style={{
                            maxWidth: "260px",
                            borderColor: "gainsboro",
                            borderRadius: 5,
                          }}
                        />
                      </div>
                      {!this.state.approvedSearchOrderId.trim() && (
                        <div style={{ color: "gray", fontSize: 13, marginBottom: 10 }}>
                          Showing approved refunds from the last 30 days. Search
                          by Refund/Order Id to look up any approved refund,
                          regardless of date.
                        </div>
                      )}
                      <div id="basicScenario" className="product-physical">
                        <Datatable
                          startToggleModal={this.startToggleModal}
                          history={this.props.history}
                          multiSelectOption={false}
                          myData={this.getApprovedRefundRequestArray()}
                          pageSize={100}
                          pagination={true}
                          class="-striped -highlight"
                        />
                      </div>
                    </TabPanel>
                  </Tabs>
                </div>
              </div>
            </div>
          </div>
        </div>
        <ToastContainer />
        {/* <!-- Container-fluid Ends--> */}
      </Fragment>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    allRefundRequests: state.payments.afterSale,
    allApprovedRefundRequests: state.payments.approvedAfterSale,
    allUser: state.users.users,
  };
};

export default connect(mapStateToProps, {
  getAllAfterSaleRedux,
  getApprovedAfterSaleRedux,
})(RefundRequestOrder);
